import {
  ButtonLink,
  Flex,
  InfoBox,
  INFOBOX_PRIORITY,
  INFOBOX_VARIANT,
} from '@npco/zeller-design-system'
import { InvoiceItem } from 'features/Invoicing/components/Invoices/Invoice/Invoice.types'

import { translate } from 'utils/translations'

import { InvoiceItemWarningMessageContainer } from './InvoiceItemWarningMessage.styled'

export const translations = {
  createNew: translate('shared.createNew'),
  createNewAriaLabel: translate(
    'page.invoice.formSections.items.itemsWarningIconTooltipCreateNew'
  ),
  itemName: (itemName: string) =>
    translate('page.invoice.formSections.items.itemsWarningIconTooltip', {
      itemName,
    }),
  updateAriaLabel: translate(
    'page.invoice.formSections.items.itemsWarningIconTooltipUpdate'
  ),
  update: translate('shared.update'),
}

export interface InvoiceItemWarningMessageProps {
  item: InvoiceItem
  lineIndex: number
  onSaveItem: (item: InvoiceItem) => void
  onUpdateItem: (item: InvoiceItem) => void
}

export const InvoiceItemWarningMessage = ({
  item,
  lineIndex,
  onSaveItem: handleOnSaveItem,
  onUpdateItem: handleOnUpdateItem,
}: InvoiceItemWarningMessageProps) => {
  return (
    <InvoiceItemWarningMessageContainer>
      <InfoBox
        dataTestId={`invoicing-invoice-item-warning-message-${lineIndex}`}
        priority={INFOBOX_PRIORITY.DEFAULT}
        variant={INFOBOX_VARIANT.NEGATIVE}
      >
        <Flex
          alignItems="baseline"
          flexDirection="row"
          flexWrap="wrap"
          gridGap="8px"
        >
          {translations.itemName(item.name)}
          <ButtonLink
            aria-label={translations.updateAriaLabel}
            onClick={() => handleOnUpdateItem(item)}
          >
            {translations.update}
          </ButtonLink>
          <ButtonLink
            aria-label={translations.createNewAriaLabel}
            onClick={() => handleOnSaveItem(item)}
          >
            {translations.createNew}
          </ButtonLink>
        </Flex>
      </InfoBox>
    </InvoiceItemWarningMessageContainer>
  )
}
